import { render, staticRenderFns } from "./GetStartedStage.vue?vue&type=template&id=ebc45ccc&scoped=true&"
import script from "./GetStartedStage.vue?vue&type=script&lang=js&"
export * from "./GetStartedStage.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedStage.vue?vue&type=style&index=0&id=ebc45ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc45ccc",
  null
  
)

export default component.exports